import React, { Component } from "react";
import * as router from "react-router-redux";
import { connect } from "react-redux";
import { actions } from "./redux";
import { actions as loginactions } from "../../ui/Login/redux";
import { actions as tariffactions } from "../Tariffs/redux";
import CSSModules from "react-css-modules";
import { ArrowBack, Menu, Close } from "@material-ui/icons";
import MenuData from "../Realtime/MenuData/MenuData";
import { Button, Drawer, Select, MenuItem, Modal } from "@material-ui/core";
import styles from "./styles.scss";
import SmartTable from "../SmartTable/SmartTable";
import moment from 'moment';
import config from "../../boot/config";

import sites_w from "../../assets/Icons/sites_white-01.png";
import live_costs_w from "../../assets/Icons/live_costs_white-01.png";
import rules_w from "../../assets/Icons/rules_white-01.png";
import evidence_w from "../../assets/Icons/evidence_white-01.png";
import tariffs_w from "../../assets/Icons/tariffs_white-01.png";
import operations_w from "../../assets/Icons/rules_white-01.png";

import sites_b from "../../assets/Icons/sites_yellow-01.png";
import live_costs_b from "../../assets/Icons/live_costs_yellow-01.png";
import rules_b from "../../assets/Icons/rules_yellow-01.png";
import evidence_b from "../../assets/Icons/evidence_yellow-01.png";
import tariffs_b from "../../assets/Icons/tariffs_yellow-01.png";
import operations_b from "../../assets/Icons/rules_yellow-01.png";

@CSSModules(styles, { allowMultiple: true })
class Header extends Component {
   constructor(props) {
      super(props);
      this._loaded = false;
      this.state = {
          tariffOpen: false
      };

      this.compareTariff = this.compareTariff.bind(this);
   }

   componentDidUpdate() {
      this._loaded = true;
   }

   compareTariff(x) {
        return this.props.currentTariff && x && x.tariffPK === this.props.currentTariff.tariffPK && x.tariffVersion === this.props.currentTariffVersion;
   }

   render() {
      const { route } = this.props;
      return (
         <div styleName="menu" open={this.props.isOpen} stoptransitions={(!this._loaded).toString()}>
            <div styleName="wraps">
               {
                  config !== undefined && config !== null && (config.menuShowSites === true || config.menuShowSites === "true") &&
                  <Button
                     disableRipple
                     styleName="btn firstBtn"
                     isroute={(route === "/Sites").toString()}
                     onClick={() => this.props.navigate("/Sites")}
                  >
                     <div>
                        <img show={(route !== "/Sites").toString()} icontype="blue" styleName="icon" src={sites_b} />
                        <img show={(route === "/Sites").toString()} icontype="white" styleName="icon" src={sites_w} />
                        <span>Sites</span>
                     </div>
                  </Button>
               }
               {
                  config !== undefined && config !== null && (config.menuShowRules === "true" || config.menuShowRules === true) &&
                  <Button
                     disableRipple
                     styleName="btn"
                     isroute={route.startsWith("/Rules/").toString()}
                     onClick={() => this.props.navigate("/Rules/all")}
                  >
                     <div>
                        <img
                           show={(!route.startsWith("/Rules/")).toString()}
                           icontype="blue"
                           styleName="icon"
                           src={rules_b}
                        />
                        <img
                           show={route.startsWith("/Rules/").toString()}
                           icontype="white"
                           styleName="icon"
                           src={rules_w}
                        />
                        <span>Rules</span>
                     </div>
                  </Button>
               }
              {
                config !== undefined && config !== null && (config.menuShowMasterRules === "true" || config.menuShowMasterRules === true) &&
                <Button
                  disableRipple
                  styleName="btn"
                  isroute={route.startsWith("/MasterRules").toString()}
                  onClick={() => this.props.navigate("/MasterRules/All")}
                >
                  <div>
                    <img
                      show={(!route.startsWith("/MasterRules")).toString()}
                      icontype="blue"
                      styleName="icon"
                      src={operations_b}
                    />
                    <img
                      show={route.startsWith("/MasterRules").toString()}
                      icontype="white"
                      styleName="icon"
                      src={operations_w}
                    />
                    <span>Master  Rules</span>
                  </div>
                </Button>
              }
               {
                  config !== undefined && config !== null && (config.menuShowEvidence === "true" || config.menuShowEvidence === true) &&
                  <Button
                     disableRipple
                     styleName="btn"
                     isroute={route.startsWith("/Evidence").toString()}
                     onClick={() => this.props.navigate("/Evidence")}
                  >
                     <div>
                        <img
                           show={(!route.startsWith("/Evidence")).toString()}
                           icontype="blue"
                           styleName="icon"
                           src={evidence_b}
                        />
                        <img
                           show={route.startsWith("/Evidence").toString()}
                           icontype="white"
                           styleName="icon"
                           src={evidence_w}
                        />
                        <span>Evidence</span>
                     </div>
                  </Button>
               }
               {
                  config !== undefined && config !== null && (config.menuShowOperations === "true" || config.menuShowOperations === true) &&
                  <Button
                     disableRipple
                     styleName="btn"
                     isroute={route.startsWith("/Operations").toString()}
                     onClick={() => this.props.navigate("/Operations")}
                  >
                     <div>
                        <img
                           show={(!route.startsWith("/Operations")).toString()}
                           icontype="blue"
                           styleName="icon"
                           src={operations_b}
                        />
                        <img
                           show={route.startsWith("/Operations").toString()}
                           icontype="white"
                           styleName="icon"
                           src={operations_w}
                        />
                        <span>Operations</span>
                     </div>
                  </Button>
               }

               <Modal
                   open={this.state.tariffOpen}
                   style={{ display: "flex", justifyContent: "center" }}
                   onClose={() => {
                       this.setState({ tariffOpen: false });
                   }}>
                   <div className="modal-wrap">
                        <div style={{marginTop: -10, marginRight: -10, display: "flex", flexDirection: "row", cursor: "pointer"}}>
                            <div style={{flex: 1}} />
                            <Close onClick={() => this.setState({ tariffOpen: false })}/>
                        </div>
                       <div styleName="modal-title">
                            Tariffs
                       </div>
                       <SmartTable
                           rowsPerPage={10}
                           columns={1}
                           smartTableId="tarifListTable"
                           data={this.props.tariffsList}
                           useResponsiveColumns={true}
                           breakOn="sm"
                           allowColumnSort={true}
                           tableClass="table-class"
                           collapsedTableHeadersStyle="td-content responsive-header"
                           tdClass="st-td"
                           classes={styles}>
                           <thead>
                               <tr>
                                    <th></th>
                               </tr>
                           </thead>
                           <tbody>
                               {this.props.tariffsList.map((x, i) => {
                                   return (
                                       <tr key={i} styleName="table-row" onClick={() => { this.props.setTariff(x); this.setState({ tariffOpen: false }) }}>
                                            <div styleName="td-content"><div styleName="current-tariff-container"><div styleName="current-tariff" current={(this.compareTariff(x)).toString()} /></div>Tariff from&nbsp;<strong>{moment(x.appliesFrom).format('MMMM YYYY')}</strong></div>
                                       </tr>
                                   );
                               })}
                           </tbody>
                       </SmartTable>

                   </div>
               </Modal>

            </div>
            <div styleName="close-area" onClick={() => this.props.toggleOpen()} />
         </div>
      );
   }
}

const bindAction = dispatch => {
   return {
      toggleOpen: () => dispatch(actions.toggleOpen()),
      navigate: (uri, data) => dispatch(router.push(uri, data)),
      goBack: () => dispatch(router.goBack()),
      searchTariffs: () => dispatch(tariffactions.searchTariffs()),
      setTariff: (tariff) => dispatch(tariffactions.setTariff(tariff))
   };
};

const mapStateToProps = state => ({
    showSelect: state.header.showSelect,
   isOpen: state.menu.isOpen,
   route: state.router.location.pathname,
   isLoggedIn: state.login.isLoggedIn,
   currentDetails: state.login.currentDetails,
   tariffsList: state.tariffs.tariffsList,
   currentTariff: state.tariffs.currentTariff,
   currentTariffVersion: state.tariffs.currentTariffVersion,
});

export default connect(
   mapStateToProps,
   bindAction
)(Header);



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js